import { Loading, Title } from "@components";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from "styles/pages/cdp/database-management.module.scss";

const categories = [
  {
    name: "Produtos",
    show: true,
    icon: <i className="fal fa-pot-food" />,
    path: "produtos",
  },
  {
    name: "Origem",
    show: true,
    icon: <i className="fal fa-arrow-progress" />,
    path: "origem",
  },
  {
    name: "Bairro",
    show: true,
    icon: <i className="fal fa-location-crosshairs" />,
    path: "bairro",
  },
  {
    name: "Cidade",
    show: true,
    icon: <i className="fal fa-location-dot" />,
    path: "cidade",
  },
  {
    name: "Estados",
    show: true,
    icon: <i className="fal fa-map-location-dot" />,
    path: "estados",
  },
];

export default function DatabaseManagement() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  if (loading) return <Loading fullContent />;

  return (
    <>
      <Title
        title="Tratamento de base"
        backTo={{ url: "/cdp", name: "Base de dados" }}
      ></Title>

      <div className={styles.categories}>
        {categories.map((c) => {
          return (
            <Link to={c.path} key={c.name}>
              <div className={styles.category}>
                <div className="d-flex align-center">
                  <div className={styles.icon}>{c.icon}</div>
                  <p className={styles.name}>{c.name}</p>
                </div>
                <div className={styles.chevron}>
                  <i className="fas fa-chevron-right" />
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </>
  );
}
